import Service from "../../AuthService";

const InvoicePayoffOtherAccount = {
    getInvoicePayoffOtherAccount(page,data){
        return Service.get("/invoice-payoff-other-account?page="+page +
            "&account="+data.account
        );
    },
    showInvoicePayoffOtherAccount(id){
        return Service.get("/invoice-payoff-other-account/"+id);
    },
    createInvoicePayoffOtherAccount(data) {
        return Service.post("/invoice-payoff-other-account",data)
    },
    updateInvoicePayoffOtherAccount(id,data){
        return Service.put("/invoice-payoff-other-account/"+id,data);
    },
    deleteInvoicePayoffOtherAccount(id){
        return Service.delete("/invoice-payoff-other-account/"+id);
    },
    getAllAccount(){
        return Service.get("/invoice_payoff_other_account_all")
    }
};

export default InvoicePayoffOtherAccount
